import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import ResponsiveLayout from 'containers/Layouts/ResponsiveLayout'
import QuestionItem from 'containers/Examination/Presentation/QuestionItem'
import { Grid, Paper, Box, Typography, Tabs, Tab, Button } from '@material-ui/core'
import { CheckCircle } from '@material-ui/icons';

import axiosConfig from 'utils/axiosConfig'

import 'containers/Examination/Examination.css'

const StudentSubmissionsss = (props) => {
  const {exam, student} = props.match.params

  const [examDetails, setExamDetails] = useState({})
  const [studentName, setStudentName] = useState('')
  const [attempts, setAttempts] = useState([])
  const [questions, setQuestions] = useState([])
  const [activeAttempt, setActiveAttempt] = useState(0)

  const getStudentAttempDetails = () => {
    axiosConfig.get(`examinations/${exam}/submissions/${student}`)
      .then((response) => {
        let responseData = response.data
        setExamDetails(responseData.examination)
        setStudentName(responseData.studentName)
        setAttempts(responseData.attempts)
      })
  }

  const selectAttemptTab = (event, newTabIndex) => {
    setQuestions(attempts[newTabIndex].questions)
    setActiveAttempt(newTabIndex)
  }

  const updateQuestionStatus = (id, status) => {
    let attempt = attempts[activeAttempt]
    axiosConfig.post(`/attempts/${attempt.id}/update/${id}/verify-answer`, {
      status
    }).then((response) => console.log(response))

    let updatedQuestion = questions.map((q) => {
      if (q.id === id) {
        if (status === 'correct') {
          q.correct = true
        }

        if (status === 'incorrect') {
          q.correct = false
        }
      }

      return q
    })

    setQuestions(updatedQuestion)
  }

  const updateAnswerScore = (id, pts) => {
    let updatedQuestion = questions.map((q) => {
      if (q.id === id) {
        q.calculated_score = pts
      }

      return q
    })

    setQuestions(updatedQuestion)
  }

  const verify = () => {
    let attempt = attempts[activeAttempt].id
    axiosConfig.post(`/attempts/${attempt}/verify`)
      .then((response) => {
        let updatedAttempts = attempts.map((a) => {
          a.verified = 0
          if (a.id === attempt) {
            a.verified = 1
          }
          return a
        })

        setAttempts(updatedAttempts)
      })
  }

  useEffect(() => {
    if (attempts.length > 0) {
      setQuestions(attempts[activeAttempt].questions)
    }
  }, [attempts])

  useEffect(() => {
    getStudentAttempDetails()
  }, [])

  return (
    <ResponsiveLayout>
      <Grid lg={8} md={6} style={{margin: '0 auto'}}>
        <Paper className="mb-4">
          <Box padding={3}>
            <Link to={`/examinations/${exam}/submissions`}>
              <i className="fa fa-arrow-left"></i> &nbsp; Back to submissions
            </Link>
            <Typography variant="h6">{examDetails.name}</Typography>
            <Typography variant="subtitle1">{examDetails.description}</Typography>
            <hr />
            <Box paddingTop={1} display="flex" whiteSpace={2} gridGap={30}>
              <Box>
                <i className="fa fa-user"></i> Student: {studentName}
              </Box>
              <Box>
                <i className="fa fa-dice-three"></i> {attempts.length} total attempt(s)
              </Box>
            </Box>
          </Box>
        </Paper>

        {attempts.length > 0 && <Paper>
          <Box>
            <Box paddingTop={3} paddingLeft={3} paddingRight={3}>
              <Tabs value={activeAttempt} onChange={selectAttemptTab} className="border-b-1 border-b-black">
                {attempts.length > 0 && attempts.map((attempt, index) => (
                  <Tab key={index} textColor="primary" indicatorColor="primary" label={`Attempt #${index + 1} ${attempt.verified ? '[Score Verified]' : ''}`} />
                ))}
              </Tabs>
            </Box>

            <Box padding={3} style={{backgroundColor: '#d1d1d138'}}>
              {questions.length > 0 && questions.map((q) => (
                <QuestionItem
                  key={q.id}
                  question={q}
                  checking={true}
                  updateStatus={updateQuestionStatus}
                  updateScore={updateAnswerScore}
                />
              ))}
            </Box>
            <Box padding={3} display="flex" justifyContent="end">
              <Button variant="contained" color="primary" onClick={verify}>
                <i className="fa fa-check-circle"></i> &nbsp; Mark This Attempt Verified
              </Button>
            </Box>
          </Box>
        </Paper>}

        {attempts.length === 0 && (
          <Typography variant="h5" style={{textAlign: 'center'}}>No answers submitted yet</Typography>
        )}
      </Grid>
    </ResponsiveLayout>
  )
}

export default StudentSubmissionsss